import { Injectable } from '@angular/core';
import { LocalService } from './local.service';
import { CONSTANTS } from '../../config';

@Injectable()
export class AuthService {

  getToken(): any {
    return LocalService.get('token');
  }

  setToken(token: string): void {
    LocalService.set('token', token);
  }

  flushToken(): void {
    LocalService.flush('token');
  }

  clearAll(): void {
    LocalService.flush();
  }

  get isAuthenticated(): boolean {
    const auth = !!(this.accessToken && this.getToken());
    return auth;
  }

  set accessToken(token: string) {
    LocalService.set(CONSTANTS.KEYS.ACCESS_TOKEN, token);
  }

  get accessToken(): string {
    return LocalService.get(CONSTANTS.KEYS.ACCESS_TOKEN);
  }

  set accessTokenExpiry(token: string) {
    LocalService.set(CONSTANTS.KEYS.ACCESS_TOKEN_EXPIRY, token);
  }

  get accessTokenExpiry(): string {
    return LocalService.get(CONSTANTS.KEYS.ACCESS_TOKEN_EXPIRY);
  }

  set refreshToken(token: string) {
    LocalService.set(CONSTANTS.KEYS.REFRESH_TOKEN, token);
  }

  get refreshToken(): string {
    return LocalService.get(CONSTANTS.KEYS.REFRESH_TOKEN);
  }

  set refershTokenExpiry(token: string) {
    LocalService.set(CONSTANTS.KEYS.REFRESH_TOKEN_EXPIRY, token);
  }

  get refershTokenExpiry(): string {
    return LocalService.get(CONSTANTS.KEYS.REFRESH_TOKEN_EXPIRY);
  }

  get idToken(): string {
    return LocalService.get(CONSTANTS.KEYS.ID_TOKEN);
  }

  set idToken(token: string) {
    LocalService.set(CONSTANTS.KEYS.ID_TOKEN, token);
  }

  get codeVerifier(): string {
    return LocalService.get(CONSTANTS.KEYS.CODE_VERIFIER);
  }

  set codeVerifier(code: string) {
    LocalService.set(CONSTANTS.KEYS.CODE_VERIFIER, code);
  }

  get oidcState(): string {
    return LocalService.get(CONSTANTS.KEYS.OIDC_STATE);
  }

  set oidcState(state: string) {
    LocalService.set(CONSTANTS.KEYS.OIDC_STATE, state);
  }

  flushCodeVerifier(): void {
    LocalService.flush(CONSTANTS.KEYS.CODE_VERIFIER);
  }

  flushOidcState(): void {
    LocalService.flush(CONSTANTS.KEYS.OIDC_STATE);
  }

  storeTokens(tokens: any): void {
    const currentTime = Math.floor(Date.now() / 1000);
    const accessTokenExpiry = currentTime + tokens.expires_in;
    const refreshTokenExpiry = currentTime + (30 * 24 * 60 * 60);

    this.accessToken = tokens.access_token;
    this.accessTokenExpiry = accessTokenExpiry.toString();

    this.refreshToken = tokens.refresh_token;
    this.refershTokenExpiry = refreshTokenExpiry.toString();

    this.idToken = tokens.id_token;
  }

  set userProfile(userProfile: any) {
    LocalService.set(CONSTANTS.KEYS.USER_PROFILE, userProfile);
  }

  get userProfile(): any {
    return LocalService.get(CONSTANTS.KEYS.USER_PROFILE);
  }

  set returnUrl(returnUrl: string) {
    LocalService.set(CONSTANTS.KEYS.RETURN_URL, returnUrl);
  }

  get returnUrl(): string {
    return LocalService.get(CONSTANTS.KEYS.RETURN_URL);
  }

  flushReturnUrl(): void {
    LocalService.flush(CONSTANTS.KEYS.RETURN_URL);
  }

}
